export const environment = {

  baseUrl: 'https://s10plus.com:8443/wsqa/rest/action/',
  idApplication: "44"

};
